import { Box,  Button,  Grid, TextField} from '@mui/material';
import React, { useEffect } from 'react';
import { BasicCheckBox } from '../../shared/basicCheckBox';
import { useMemberContext } from '../../context/memberContext';


export default function MemberPersonalPageTab() {

    const [athletePage, setAthletePage] = React.useState<string>('');
    const [isPublic, setIsPublic] = React.useState<boolean>(false);

    const { member, updatePersonalPage, resetPin} = useMemberContext();

    /**
     * Gets the root URL of the app based on the current window location.
     */
    function getAppRoot(): string {
        const { protocol, host } = window.location;
        return `${protocol}//${host}`;
    }

    const runnerPage = `${getAppRoot()}/orgseason/${member?.orgSeason.id}/runner/${member?.id}`;
    const defaultAthletePage = `${getAppRoot()}/orgSeason/${member?.orgSeason.id}/athlete/${member?.id}`;
    const updateCardDataPage = `${getAppRoot()}/card-data/code/${member?.secCode}`;


         useEffect(() => {
                if (member) {
                    setAthletePage(member.athletePage ?? '');
                    setIsPublic(member.isPublic ?? false);
                }
            }, [member]);
            

   function handleAthletePageChange(e: React.ChangeEvent<HTMLInputElement>) {
        const { value } = e.target;
        setAthletePage(value);
    }

    function submitForm() {
        updatePersonalPage(athletePage, isPublic);
    }

    function setDefault() {
        setAthletePage(defaultAthletePage);
    }


    return (
        <Grid container spacing={5}>
            <Grid item xs={12}>
                <Grid item>
                <Box mb={2}>
                   <BasicCheckBox label='Public' checked={isPublic} onChange={(e, checked) => setIsPublic(checked)} />
                   </Box>
                   <br/>
                </Grid>

                <Grid item>
                <Box mb={2}>
                       <Box>
                           <a href={runnerPage} target="_blank" rel="noopener noreferrer">
                               Visit Runner Page
                           </a>
                       </Box>
                   </Box>
                   <br/>
                </Grid>

                  <Grid item>
                <Box mb={2}>
                       <Box>
                           <a href={updateCardDataPage} target="_blank" rel="noopener noreferrer">
                               Update Card Data Page
                           </a>
                       </Box>
                   </Box>
                   
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={resetPin}>
                        Clear PIN
                    </Button>
                   <br/><br/><br/>
                </Grid>

                <Grid item>
                <Box mb={2}>
                {isPublic && athletePage && (
                       <Box>
                           <a href={athletePage} target="_blank" rel="noopener noreferrer">
                               Visit Athlete Page
                           </a>
                       </Box>
                   )}
                   </Box>
                   <br/>
                </Grid>

                <Grid item>
                <Box mb={2}>
                    <TextField id="athletePage"
                        label="Personal Page"
                        variant="outlined"
                        size="small"
                        helperText='50 character limit'
                        inputProps={{ maxLength: 50 }}
                        value={athletePage}
                        style={{ width: 1200 }}
                        onChange={handleAthletePageChange} />

                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={setDefault}
                    >
                        Set Default
                    </Button>

                        <br/>
                </Box>
                </Grid>
                <Grid item>
                    <Box mb={2}>
                    <br/>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={submitForm}
                    >
                        Submit
                    </Button>
                    </Box>
                    </Grid>
            </Grid>
        </Grid>
    )
}